import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { TreeNode } from '@shared/components/tree-select/Domain/treeNode.model';

@Component({
  selector: 'app-tree-select-node',
  standalone: true,
  imports: [NgIf, NgForOf, NgClass],
  templateUrl: './tree-select-node.component.html',
  styleUrl: './tree-select-node.component.scss',
})
export class TreeSelectNodeComponent {
  @Input() node!: TreeNode;
  @Input() selectionMode: 'single' | 'multiple' = 'single';
  @Input() selectedNodes: TreeNode[] = [];

  @Output() leafSelected = new EventEmitter<TreeNode>();

  toggle(event: MouseEvent) {
    event.stopPropagation();
    this.node.expanded = !this.node.expanded;
  }

  isSelected(): boolean {
    return this.selectedNodes.some((n) => n.key === this.node.key);
  }

  selectLeaf() {
    if (this.node.leaf) {
      this.leafSelected.emit(this.node);
    }
  }

  onNodeRowClick(event: MouseEvent) {
    event.stopPropagation();

    if (this.node.leaf) {
      this.selectLeaf();
    } else {
      this.node.expanded = !this.node.expanded;
    }
  }
}
